const FALLBACK_ROW_HEIGHT = 24;

const rowHeightFor = (element: HTMLTextAreaElement) => {
  const style = getComputedStyle(element);
  const lineHeight = Number.parseFloat(style.lineHeight);
  if (Number.isFinite(lineHeight) && lineHeight > 0) {
    return lineHeight;
  }
  const fontSize = Number.parseFloat(style.fontSize);
  if (Number.isFinite(fontSize) && fontSize > 0) {
    return fontSize * 1.2;
  }
  return FALLBACK_ROW_HEIGHT;
};

export const fitTextareaHeight = (
  element: HTMLTextAreaElement,
  {
    maxRows = 10,
    minRows = 3,
  }: {
    maxRows?: number;
    minRows?: number;
  } = {},
) => {
  const rowHeight = rowHeightFor(element);
  const minHeight = rowHeight * minRows;
  const maxHeight = rowHeight * maxRows;
  element.style.overflowY = 'hidden';
  element.style.height = '0px';
  const contentHeight = element.scrollHeight;
  const nextHeight = Math.min(maxHeight, Math.max(minHeight, contentHeight));
  element.style.height = `${nextHeight}px`;
  element.style.overflowY = contentHeight > maxHeight ? 'auto' : 'hidden';
  element.style.resize = 'none';
};
